module.exports = {
  8: '2rem',
  20: '5rem',
  28: '7rem',
  25: '6.4rem',
  40: '10rem',
  76.2: '19.2rem',
};
